module.exports = __webpack_public_path__ + "img/couples-068.e6141ef9.jpg";